import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from '../button';

const ConsolidationPdfButton = ({ editable, hasPrice, calculate }) => {
  if (!editable || !hasPrice) return null;

  return (
    <Button
      style={{ marginTop: '18px' }}
      content={<FormattedMessage id="Application.GetContractDraft" />}
      width="175px"
      onClick={calculate}
    />
  );
};

ConsolidationPdfButton.propTypes = {
  editable: PropTypes.bool.isRequired,
  hasPrice: PropTypes.bool.isRequired,
  calculate: PropTypes.func.isRequired,
};

export default ConsolidationPdfButton;
